var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExternalLink = function SvgIconExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.064 10.446v9.635h-2V13.86L23.74 26.185l-1.414-1.414L34.65 12.446h-6.22v-2zm-25.129 6.968v18.14h18.14v2h-20.14v-20.14z",
    clipRule: "evenodd"
  })));
};
export { SvgIconExternalLink as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OSA0OCIgZmlsbD0ibm9uZSI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICAgIGQ9Ik0zOC4wNjQgMTAuNDQ2djkuNjM1aC0yVjEzLjg2TDIzLjc0IDI2LjE4NWwtMS40MTQtMS40MTRMMzQuNjUgMTIuNDQ2aC02LjIydi0yaDkuNjM0Wm0tMjUuMTI5IDYuOTY4djE4LjE0aDE4LjE0djJoLTIwLjE0di0yMC4xNGgyWiIgY2xpcC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";